import React from "react";
import {FormComponent} from "../../components/FormComponent";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {FormGroup} from "../../components/FormComponent/FormGroup";

export class ProductImport extends FormComponent {

    componentDidMount() {
        let [id] = this.getParams();

        this.request.fetch('/client/get', {id: id})
            .then((data: { item: { [key: string]: string }, rights: string[] } | {
                message: string | string[]
            } | any) => {
                this.setState({item: data?.item, rights: data?.rights, message: data?.message});
            }).catch(error => {
            this.onError(error);
        });
    }

    render() {
        return (
            <>
                <div className="row">
                    <div className="col-12">
                        <h5>{this.dictionary.get['import-product']}</h5>
                    </div>
                </div>

                <form className="x-form" action="/product/import"
                      encType="multipart/form-data" onSubmit={this.handleSubmit}>

                    <input type="hidden" name="key"/>

                    <div className="row">

                        <div className="col-md-12 col-lg-10 col-xl-8 col-xxl-6">
                            <br/>&nbsp;
                            <h5>{this.dictionary.get['import-xlsx']}</h5>

                            <FormGroup.Info>{this.dictionary.get['import-values-help']}</FormGroup.Info>

                            <FormGroup.Input {...{
                                id: 'product',
                                label: 'import-product',
                                required: true,
                                type: 'file'
                            }}/>

                            <FormSubmit/>
                        </div>
                    </div>
                </form>


                <div className="row">
                    <div className="col-12">
                        <br/>&nbsp;
                        <h5>{this.dictionary.get['transfer-product']}</h5>

                        {/*{this.state.items.map(function (elem: any) {*/}
                        {/*    return (*/}
                        {/*        <form className="x-form" action="/importProducts"*/}
                        {/*              encType="multipart/form-data" onSubmit={this.handleSubmit}>*/}

                        {/*            <input type="hidden" name="service_id" value="1"/>*/}

                        {/*            <div className="row">*/}

                        {/*                <div className="col-md-12 col-lg-10 col-xl-8 col-xxl-6">*/}
                        {/*                    <br/>&nbsp;*/}
                        {/*                    <h6>{this.dictionary.get['business-central-import-product']}</h6>*/}

                        {/*                    <FormSubmit label={this.dictionary.get['import-product']}/>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        </form>*/}
                        {/*    )*/}
                        {/*})}*/}
                    </div>
                </div>

            </>
        );
    }
}